module.exports = __webpack_public_path__ + "static/media/train.2d474119.svg";